import React, { useEffect, useState } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";

const useRoutePath = (props) => {
    const match = useRouteMatch();
    const location = useLocation();

    const splitPath = match.path.replace(/^\//, '').split('/');
    const splitUrl = match.url.replace(/^\//, '').split('/');

    const [queryParams, setQueryParams] = useState({});
    useEffect(() => {
        const queryParamsTemp = {};
        const queryParams_ = new URLSearchParams(location.search);
        for (const [key, value] of queryParams_) queryParamsTemp[key] = value;
        setQueryParams(queryParamsTemp);
    }, [location.search]);

    const [parentPath, setParentPath] = useState('/');
    const [parentPathName, setParentPathName] = useState('');
    useEffect(() => {
        if (match.path.indexOf("/cms") === 0) {
            setParentPath("/cms");
            setParentPathName("CMS");
        } else {
            if (splitUrl[0]) setParentPath("/" + splitUrl[0]);
            setParentPathName(
                splitUrl[0].replace(/^[a-z]/, (c) => c.toUpperCase())
            );
        }
    }, [match.path]);

    const [upperUrl, setUpperUrl] = useState('/');
    useEffect(() => {
        if(splitUrl.length === 0) {
            setUpperUrl('/');
        } else {
            setUpperUrl(`/${splitUrl.slice(0, splitUrl.length - 1).join('/')}`);
        }
    }, [match.url]);

    return {
        match,
        location,
        parentPath,
        parentPathName,
        upperUrl,
        pathParams: { ...match.params },
        queryParams,
    };
};

export default useRoutePath;
